import { NgModule } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateService, TranslatePipe, provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader, TranslateHttpLoader } from '@ngx-translate/http-loader';

import { HttpJsonUtilities } from './http/http-json-utilities.service';
import { ActivityService } from './activity/activity.service';
import { HttpConfigService } from './http/http-config.service';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './services/auth.interceptor';

import { AccountClient, API_BASE_URL, ClientClient, SamplingProfileClient, SignalClient, StatisticsClient, ThemeClient, UserAccountClient, VehicleClient } from './models/models.swagger.generated';

import { AppErrorMessagesService } from './services/app-error-messages.service';
import { EnumTranslationService } from './services/enum-translation.service';

import { environment } from '../../environments/environment';

import { SpinnerService } from './spinner/spinner.service';
import { LoginProxy } from './http/login-proxy.service';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { CommandColumnService, EditService, FilterService, PageService, SearchService, SortService, ToolbarService } from '@syncfusion/ej2-angular-grids';
import { EnumFilterService } from './services/enum-filter.service';

export function tokenGetter() {
  return localStorage.getItem(environment.localStorageToken);
}

@NgModule({
  declarations: [],
  bootstrap: [],
  exports: [],
  imports: [
    FontAwesomeModule,
    /* AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApisKey
    }), */
    NgIdleKeepaliveModule.forRoot()
  ],
  providers: [
    provideHttpClient(),
    provideTranslateService({
      lang: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: './assets/i18n/',
        suffix: '.json'
      })
    }),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: API_BASE_URL, useValue: environment.apiServerUrl },
    HttpClient,
    HttpJsonUtilities,
    HttpConfigService,
    SpinnerService,
    TranslateService,
    TranslatePipe,
    ActivityService,
    LoginProxy,
    AppErrorMessagesService,
    EnumTranslationService,
    EnumFilterService,
    /* swagger clients */
    AccountClient,
    UserAccountClient,
    ClientClient,
    ThemeClient,
    StatisticsClient,
    // Collector configuration surface: sampling profiles, the signal catalog picker, and the vehicle
    // list used for profile assignment and availability context.
    SamplingProfileClient,
    SignalClient,
    VehicleClient,
    /* Syncfusion services */
    PageService,
    ToolbarService,
    FilterService,
    SortService,
    EditService,
    CommandColumnService,
    SearchService,
    provideHttpClient(withXhr(), withInterceptorsFromDi()),
  ] })
export class BaseModule { }
